import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'careers_page-view_openings-click';
/**
 * Track when view openings button is clicked.
 */ export function trackCareersPageViewOpeningsClick() {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: true
    });
}
